<template>
	<div class="xs-12 flex wrap xs-bottom p4">
		<div class="xs-12 flex wrap">
			<!-- parent typeId -->
			<core-form-input
				componentName="j-base-input-text"
				name="parentTypeId"
				:label="$t('parent_type_id')"
				class="mb2"
				v-model="parentTypeId"
				:isReadOnly="true"
				v-if="parentTypeId"
			/>

			<core-form-input
				componentName="j-base-input-text"
				name="benefitTypeId"
				:label="$t('benefit_type_id')"
				class="mb2"
				v-model="custom.typeId"
				v-validate="'required'"
				:validationErrors="errors"
			/>

			<core-form-input
				componentName="j-base-input-text"
				name="name"
				:label="$t('name')"
				class="mb2"
				v-model="custom.name"
				v-validate="'required'"
				:validationErrors="errors"
			/>

			<core-form-input
				componentName="j-base-select"
				name="scalar_type"
				:label="$t('type')"
				class="mb2"
				:allowSelectNothing="false"
				:options="scalarTypes"
				v-model="custom.scalarType"
			/>

			<core-form-input
				componentName="j-base-input-text"
				name="input_value"
				:label="$t('input_value')"
				class="mb2"
				v-model="custom.inputValue"
			/>
		</div>

		<div class="flex xs-between mt6 xs-12">
			<j-button @click="$emit('hide')" type="bordered">
				{{ $t("cancel") }}
			</j-button>
			<j-button @click="onAdd">{{ $t("add") }}</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
export default {
	components: {
		CoreFormInput,
		JButton
	},
	props: {
		selectedNode: {
			type: Object || Null
		}
	},
	data() {
		return {
			custom: {
				name: null,
				typeId: null,
				scalarType: "numberValue",
				inputValue: null
			}
		}
	},
	computed: {
		scalarTypes() {
			return [
				{ name: "Number", value: "numberValue" },
				{ name: "String", value: "stringValue" },
				{ name: "Boolean", value: "booleanValue" }
			]
		},
		parentTypeId() {
			return this.selectedNode?.typeId
		}
	},
	methods: {
		async onAdd() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			const inputValue = this.custom.inputValue

			const buildClaimedValue = type => {
				if (type === "stringValue")
					return !inputValue || !inputValue.length ? "" : inputValue
				if (type === "numberValue")
					return !inputValue || isNaN(parseFloat(inputValue))
						? 0
						: parseFloat(inputValue)
				if (type === "booleanValue")
					return !inputValue || inputValue === "false" || inputValue !== "true"
						? false
						: true
				return 0
			}

			// Massage data into proper format
			const output = {
				parentTypeId: this.parentTypeId,
				typeId: this.custom.typeId,
				name: this.custom.name,
				value: {
					[this.custom.scalarType]: buildClaimedValue(this.custom.scalarType)
				}
			}

			this.$emit("addCustomBenefit", output)
		}
	},
	mounted() {
		console.log(this.selectedNode)
	}
}
</script>

<style>
</style>
